// extracted by mini-css-extract-plugin
module.exports = {"menuBar":"_39d5T2vM5R0XaxOUoR7h9F","title":"_3fY1zyrMnS-P-FR4wumVmB","actions":"_1cLv-p0eG4O-uPrN_HBl6b","actionsItems":"_19KuQPISxwgrCmhsrD4ZXD"};